export default __webpack_public_path__ + "static/media/people.a45f2219.jpg";